/**
 * Endpoints de Preguntas frecuentes.
 *
 * Sólo lectura: la administración del FAQ sigue en el panel anterior.
 */

import { apiClient } from '@/lib/http/api-client';

import type { FaqData } from './faq.types';

export const faqKeys = {
  all: ['faq'] as const,
} as const;

export const faqApi = {
  /** Categorías, preguntas y estadísticas del FAQ. */
  get: (signal?: AbortSignal): Promise<FaqData> => apiClient.get<FaqData>('/api/faq', { signal }),
} as const;
